import { getWindowDimensions } from '@/shared/helpers/browserHelpers';
import { useEffect, useState } from 'react';

export const useWindowDimensions = (): {
  windowDimensions: {
    width: number;
    height: number;
  };
  isMobileView: boolean;
} => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [isMobileView, setIsMobileView] = useState<boolean>(windowDimensions.width < 1025);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
      setIsMobileView(getWindowDimensions().width < 1025);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { windowDimensions, isMobileView };
};
